import React, { FC, useContext } from 'react'
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'

import BookingContext from '../../contexts/booking'

const BookingStepper: FC<React.PropsWithChildren<unknown>> = () => {
  const booking = useContext(BookingContext)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Stepper 
      activeStep={booking.pageIndex} 
      orientation={isMobile ? 'vertical' : 'horizontal'}
      alternativeLabel={!isMobile}
      sx={isMobile ? { p: 2, pl: 1, pr: 1 } : undefined}
    >
      <Step
        sx={{ 
          cursor: booking.pageIndex > 0 && booking.pageScore >= 0 ? 'pointer' : 'default'
        }}
        onClick={() => {
          if(!booking.loading && booking.pageIndex > 0 && booking.pageScore >= 0) booking.openPage('product')
        }}
      >
        <StepLabel>House Size</StepLabel>
      </Step>
      <Step
        sx={{ 
          cursor: booking.pageIndex > 1 && booking.pageScore >= 1 ? 'pointer' : 'default'
        }}
        onClick={() => {
          if(!booking.loading && booking.pageIndex > 1 && booking.pageScore >= 1) booking.openPage('calendar')
        }}
      >
        <StepLabel>Calendar</StepLabel>
      </Step>
      <Step
        sx={{ 
          cursor: booking.pageIndex > 2 && booking.pageScore >= 2 ? 'pointer' : 'default'
        }}
        onClick={() => {
          if(!booking.loading && booking.pageIndex > 2 && booking.pageScore >= 2) booking.openPage('details')
        }}
      >
        <StepLabel>Details</StepLabel>
      </Step>
      <Step>
        <StepLabel>Payment</StepLabel>
      </Step>
    </Stepper>
  )
}

export default BookingStepper